import { render, staticRenderFns } from "./ContactWindow.vue?vue&type=template&id=b8bbe7be&"
import script from "./ContactWindow.vue?vue&type=script&lang=js&"
export * from "./ContactWindow.vue?vue&type=script&lang=js&"
import style0 from "./ContactWindow.vue?vue&type=style&index=0&id=b8bbe7be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports